import { createAsyncThunk } from "@reduxjs/toolkit"
import { post, put } from "helpers/api_helper"
import { GET_TAX_DETAILS, UPDATE_TAX_DETAILS } from "helpers/url_helper"

export const getTaxDetails = createAsyncThunk(
  GET_TAX_DETAILS,
  async payload => {
    const response = await post(GET_TAX_DETAILS, payload)
    return response
  }
)

export const updateTaxDetails = createAsyncThunk(
  UPDATE_TAX_DETAILS,
  async payload => {
    const response = await put(UPDATE_TAX_DETAILS, payload)
    return response
  }
)
